import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-canales-contacto',
  templateUrl: './canales-contacto.component.html',
  styleUrls: ['./canales-contacto.component.scss']
})
export class CanalesContactoComponent {
  @Input() requiereAutenticacion: boolean;

  @Input() titulo: string = "";
  @Input() ir_a_tramite: boolean = false;
  @Input() ir_a_tramite_url: string = null;
  @Output("ir_a_tramite_funcion") ir_a_tramite_funcion: EventEmitter<any> = new EventEmitter<any>();

  @Input() enviar_consulta: boolean = false;
  @Input() enviar_consulta_url: string = null;
  @Output("enviar_consulta_funcion") enviar_consulta_funcion: EventEmitter<any> = new EventEmitter<any>();

  @Input() messenger: boolean = false;
  @Input() messenger_url: string = null;
  @Output("messenger_funcion") messenger_funcion: EventEmitter<any> = new EventEmitter<any>();

  ir_a_tramite_click(event: MouseEvent) {
    // Si recibo URL, navego
    if (this.ir_a_tramite_url) {
      window.open(this.ir_a_tramite_url, '_blank');
      return;
    }

    // Si recibo función, ejecuto el emit de la función
    if (this.ir_a_tramite_funcion.observers.length > 0) {
      this.ir_a_tramite_funcion.emit();
      return;
    }

    // Si no hay nada
    event.preventDefault();
  }

  enviar_consulta_click(event: MouseEvent) {
    // Si recibo URL, navego
    if (this.enviar_consulta_url) {
      window.open(this.enviar_consulta_url, '_blank');
      return;
    }

    // Si recibo función, ejecuto el emit de la función
    if (this.enviar_consulta_funcion.observers.length > 0) {
      this.enviar_consulta_funcion.emit();
      return;
    }

    // Si no hay nada
    event.preventDefault();
  }

  messenger_click(event: MouseEvent) {
    // Si recibo URL, navego
    if (this.messenger_url) {
      window.open(this.messenger_url, '_blank');
      return;
    }

    // Si recibo función, ejecuto el emit de la función
    if (this.messenger_funcion.observers.length > 0) {
      this.messenger_funcion.emit();
      return;
    }

    // Si no hay nada
    event.preventDefault();
  }
}
